import { Link } from "react-router-dom"
import { Navbar, Nav } from "react-bootstrap"
import ErrorPanel from "ErrorPanel"
import AnimatedLogo from 'Home/AnimatedLogo'
import History from 'History';

export default function NavBar() {
	return (
		<Navbar bg="light" expand="lg" className="p-3 mb-3 sticky-top">
			<Navbar.Brand className="d-flex align-items-center">
				<a className="nav-link" href="/">
					<AnimatedLogo width="50" height="50" />
				</a>
			</Navbar.Brand>
			<Navbar.Toggle aria-controls="navbar" />
			<Navbar.Collapse id="navbar">
				<Nav className="me-auto">
					<Link className="nav-link" to="/">File</Link>
					<Link className="nav-link" to="/block-diagram/">Block Diagram</Link>
					<Link className="nav-link" to="/parameters/">Parameters</Link>
					<Link className="nav-link" to="/timing-diagram/">Timing Diagram</Link>
					<Link className="nav-link" to="/register-map/">Register Map</Link>
					<Link className="nav-link" to="/simulation/">Simulation</Link>
					<Link className="nav-link" to="/documents/">Documents</Link>
				</Nav>
				<History />
				<ErrorPanel />
			</Navbar.Collapse>
		</Navbar>
	)
}
